import React from "react";
import { gbp } from "../lib/iht";
import { Slider } from "./ui/slider";

export const AllowanceSlider = ({ label, hint, base, value, onChange, testid }) => {
  const pctVal = Math.round((value || 0) * 100);
  const amount = base * (value || 0);
  return (
    <div className="flex flex-col gap-2.5">
      <div className="flex items-end justify-between gap-3">
        <div>
          <span className="text-sm font-bold">{label}</span>
          {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
        </div>
        <div className="text-right shrink-0">
          <span data-testid={`${testid}-amount`} className="font-mono font-bold text-lg leading-none">
            {gbp(amount)}
          </span>
          <p data-testid={`${testid}-pct`} className="text-xs font-bold text-foreground/60 leading-none mt-0.5">
            {pctVal}% of {gbp(base)}
          </p>
        </div>
      </div>
      <Slider
        data-testid={testid}
        value={[pctVal]}
        min={0}
        max={100}
        step={1}
        onValueChange={(x) => onChange(x[0] / 100)}
      />
    </div>
  );
};
